@if (visible) {
<aside
  [ngClass]="{
    'w-[280px] fixed border bg-white dark:bg-primary-900 text-primary-900 dark:text-primary-50 h-[calc(100svh-117.5px)] z-[100] ms-4':
      visible,
    'xl:w-[240px]': visible && mode !== 'overlay'
  }"
>
  <app-menu class="h-full"></app-menu>
</aside>
}
